'use strict';

var angular = require('angular');
var _ = require('lodash');

require('../libs/angular-1.6.4/angular-sanitize.min');

// modules
require('./modules/_app');
// factories
require('./factories/_searchService');

//controllers
require('./controllers/_eventSearchService');
require('./controllers/_calendarIo');
require('./controllers/_slider');
//filters
require('./filter/_dateFilter');


// directives
require('./directives/_headerSearch');
require('./directives/_modalOrchestrator');
require('./directives/_searchPage');
require('./directives/_bgImageSrcSet');

// directives - Angular templates
require('./templates/dictionaryEntry/_dictionaryEntry');
require('./templates/mediaGallery/_mediaGallery');
require('./templates/article/_article');

// validators
require('./validators/_phoneNumberValidator');
require('./validators/_compareValueValidator');
require('./validators/_emailValidator');
require('./validators/_passwordValidator');

// directives - partials

// directives - partials - modals

// directives - blocks

// directives - pages

// directives - nodes

// todo: Look at _LayoutScriptsHead.cshtml and _LayoutScriptsBody.cshtml - make sure we don't have any overlap 
//require('../libs/bootstrap/javascripts/bootstrap.min');
require('./utilities/_matchHeight');


$(document).ready(function () {

    $('a').each(function () {
        if ($(this).isExternal()) {
            $(this).addClass('external');
            $(this).append('<i class="fa fa-external-link external-link"></i>');
            $(this).attr('target', '_blank');
        }
    });


    $.ui.autocomplete.prototype._resizeMenu = function () {
        var ul = this.menu.element;
        ul.outerWidth(this.element.outerWidth());
    }

    $('.sticky-chat').click(function (e) {
        $('.LPMcontainer').trigger('click');
    });

    $('.login-link').click(function (e) {
        $("#login-form span:contains('Log In')").trigger('click');
    });

    var dfd = $.Deferred();
    var checkChatOffline = setInterval(function () {
        if ($(".LPMimage").length) {
            dfd.resolve();
            clearInterval(checkChatOffline);
        }
    }, 1000);



    dfd.done(function () {
        var offline = $('.LPMimage').attr("src").indexOf('repoffline') !== -1;
        if (offline) {
            $(".sticky-chat span").text("CHAT OFFLINE");
        } else {
            $(".sticky-chat span").text("LIVE CHAT");
        }

    });
});

$(window).on('load', function () {
	var options = {
		byRow: true,
		property: 'height',
		target: null,
		remove: false
	};

	var $equalizeColumnContainers = $("[data-column-equalizer]");

	$equalizeColumnContainers.each(function () {
		var $this = $(this);
		var $items = $this.children('[data-equalizer-watch]');
		$items.matchHeight(options);
	});
});


$.fn.isExternal = function () {
    var host = window.location.host;
    var hr = this.attr('href');
    var link = $('<a>', {
        href: hr
    })[0].hostname;  
    
    return (link && link !== host);
};
// https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
if (!Array.prototype.findIndex) {
    Object.defineProperty(Array.prototype, 'findIndex', {
        value: function (predicate) {
            // 1. Let O be ? ToObject(this value).
            if (this === null) {
                throw new TypeError('"this" is null or not defined');
            }

            var o = Object(this);

            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;

            // 3. If IsCallable(predicate) is false, throw a TypeError exception.
            if (typeof predicate !== 'function') {
                throw new TypeError('predicate must be a function');
            }

            // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
            var thisArg = arguments[1];

            // 5. Let k be 0.
            var k = 0;

            // 6. Repeat, while k < len
            while (k < len) {
                // a. Let Pk be ! ToString(k).
                // b. Let kValue be ? Get(O, Pk).
                // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                // d. If testResult is true, return k.
                var kValue = o[k];
                if (predicate.call(thisArg, kValue, k, o)) {
                    return k;
                }
                // e. Increase k by 1.
                k++;
            }

            // 7. Return -1.
            return -1;
        },
        configurable: true,
        writable: true
    });
}

if (!String.prototype.startsWith) {
    String.prototype.startsWith = function (search, pos) {
        return this.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
    };
}





//////////////////
// WEBPACK FOOTER
// ./static/common/js/common.js
// module id = 1
// module chunks = 0